import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private baseUrl = environment.apiUrl;
  userDetails: any;

  constructor(private http: HttpClient) { }

  // login(payload: { mobile: string; password: string }) {
  //   return this.http.post(
  //     `${this.baseUrl}/admin/login`,
  //     payload
  //   ).pipe(
  //     tap((res: any) => {
  //       if (res?.status && res?.data?.token) {
  //         localStorage.setItem('access_token', res.data.token);
  //         // console.log("adminId",res?.data)
  //         const adminId = res?.data?.profile?.id;
  //         console.log("login adminid", adminId)
  //         if (adminId) {
  //           localStorage.setItem('admin_id', adminId.toString());
  //           localStorage.setItem('user_data', JSON.stringify(res.data));

  //         }
  //       }
  //     })
  //   );
  // }
  // getUser() {
  //   if (!this.userDetails) {
  //     const data = localStorage.getItem('user_data');
  //     this.userDetails = data ? JSON.parse(data) : null;
  //   }
  //   return this.userDetails;
  // }
  // getToken(): string | null {
  //   return localStorage.getItem('access_token');
  // }
  // isAuthenticated(): boolean {
  //   return !!this.getToken();
  // }
  // getAdminId(): number | null {
  //   const id = localStorage.getItem('admin_id');
  //   console.log("id", id)
  //   return id ? Number(id) : null;
  // }

  // logout() {
  //   const token = this.getToken();

  //   const headers = new HttpHeaders({
  //     'Authorization': `Bearer ${token}`,
  //     'Accept': 'application/json'
  //   });

  //   return this.http.post(
  //     `${this.baseUrl}/admin/logout`,
  //     {},
  //     { headers }
  //   ).pipe(
  //     tap(() => {
  //       localStorage.removeItem('access_token');
  //       localStorage.removeItem('admin_id');
  //     })
  //   );
  // }

  // signupPage(body: any) {
  //   return this.http.post(
  //     `${this.baseUrl}/customer/register`,
  //     body)

  // }


    login(payload: { mobile: string; password: string }): Observable<any> {

    return this.http.post(
      `${this.baseUrl}/admin/login`,
      payload
    ).pipe(
      tap((res: any) => {

        if (res?.status && res?.data?.token) {

          this.setSession(
            res.data.token,
            res.data
          );

          const adminId = res?.data?.profile?.id;

          if (adminId) {
            localStorage.setItem(
              'admin_id',
              adminId.toString()
            );
          }
        }
      })
    );
  }



  private setSession(
    token: string,
    userData: any
  ): void {

    localStorage.setItem(
      'access_token',
      token
    );

    localStorage.setItem(
      'user_data',
      JSON.stringify(userData)
    );
  }


 
  getUser(): any {

    if (!this.userDetails) {

      const data = localStorage.getItem(
        'user_data'
      );

      this.userDetails = data
        ? JSON.parse(data)
        : null;
    }

    return this.userDetails;
  }



  getToken(): string | null {

    return localStorage.getItem(
      'access_token'
    );
  }


 
  hasToken(): boolean {

    return !!this.getToken();
  }



  getAdminId(): number | null {

    const id = localStorage.getItem(
      'admin_id'
    );

    return id
      ? Number(id)
      : null;
  }


  
  clearSession(): void {

    localStorage.removeItem(
      'access_token'
    );

    localStorage.removeItem(
      'admin_id'
    );

    localStorage.removeItem(
      'user_data'
    );

    this.userDetails = null;

    sessionStorage.clear();
  }


  logout(): Observable<any> {

    const token = this.getToken();

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    });

    return this.http.post(
      `${this.baseUrl}/admin/logout`,
      {},
      { headers }
    ).pipe(
      tap(() => {
        this.clearSession();
      })
    );
  }


  signupPage(body: any) {

    return this.http.post(
      `${this.baseUrl}/customer/register`,
      body
    );
  }
  validateToken(): Observable<any> {
  return this.http.get(
    `${this.baseUrl}/admin/dashboard`
  );
}
}
